export default "__VITE_ASSET__Ckqjv6kA__"